import { MonthView } from "@devexpress/dx-react-scheduler-material-ui"
import calendarStyles from "../../../styles/EventsCalendarStyles"
import { useTheme } from '@mui/material/styles'

export const tableCellMonth = (props: any) => {
  const theme = useTheme()
  const classes = calendarStyles(theme, {
    top: 0,
    shadedHeight: 0,
    backgroundColor: '',
    color: ''
  })
  return <MonthView.TimeTableCell {...props} sx={classes.monthCell} />
}
